import { asksFirst } from "@/lib/consent";
import { useHere } from "./catalogue";

/**
 * Whether analytics waits for a yes where this visitor is, from the
 * country the edge reads from their address (`places/here`). Undefined
 * until it is read, or while `enabled` is false; a failed read asks first.
 */
export function useAsksFirst(enabled = true): boolean | undefined {
    const here = useHere(enabled);
    if (here.isError) return true;
    if (!here.data) return undefined;
    return asksFirst(here.data.country?.country);
}
